/**
 * EmployeeStatusChip Component
 * Chip component for displaying employee status with colors
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { 
  CheckCircle, 
  Block, 
  MedicalServices, 
  PersonOff 
} from '@mui/icons-material';
import { 
  EmployeeStatus, 
  EMPLOYEE_STATUS_LABELS, 
  EMPLOYEE_STATUS_COLORS 
} from '../../types/employee';

interface EmployeeStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: EmployeeStatus;
  showIcon?: boolean;
}

const statusIcons: Record<EmployeeStatus, React.ReactElement> = {
  [EmployeeStatus.ATIVO]: <CheckCircle />,
  [EmployeeStatus.SUSPENSO]: <Block />,
  [EmployeeStatus.AFASTADO]: <MedicalServices />,
  [EmployeeStatus.DEMITIDO]: <PersonOff />,
  [EmployeeStatus.INATIVO]: <PersonOff />,
  [EmployeeStatus.LICENCA]: <MedicalServices />
};

export const EmployeeStatusChip: React.FC<EmployeeStatusChipProps> = ({
  status,
  showIcon = true,
  size = 'small',
  ...props
}) => {
  const label = EMPLOYEE_STATUS_LABELS[status];
  const color = EMPLOYEE_STATUS_COLORS[status];
  const icon = showIcon ? statusIcons[status] : undefined;

  return (
    <Chip
      label={label}
      size={size}
      icon={icon}
      sx={{
        bgcolor: `${color}.100`,
        color: `${color}.800`,
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: `${color}.700`
        }
      }}
      {...props}
    />
  );
};
